module.exports = __webpack_public_path__ + "img/31.8c9e0d6d.png";